import {
  REPORT_PREVIEW_ERROR,
  REPORT_PREVIEW_REQUEST,
  REPORT_PREVIEW_SUCCESS,
} from 'common/actions/report-preview-actions';

export default (state = {}, action) => {
  switch (action.type) {
    case REPORT_PREVIEW_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
        params: action.params,
      };
    case REPORT_PREVIEW_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
        params: action.params,
      };
    case REPORT_PREVIEW_SUCCESS:
      return {
        ...state,
        error: null,
        html: action.html,
        loading: false,
        params: action.params,
      };
    default:
      return state;
  }
};
